export default {"src":"/_next/static/media/Target.6c533761.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};